/**
 * Contact page — the mock-up's "describe the problem or the business goal"
 * layout: promises on the left, the form on the right.
 */
import { el } from "../core/dom.js";
import type { AppContext } from "../core/context.js";
import { applyPageSeo } from "../core/seo.js";
import { breadcrumbs, markerList } from "../components/common.js";
import { contactForm } from "../components/forms.js";

export async function contactView(ctx: AppContext): Promise<HTMLElement> {
	const copy = ctx.copy();
	const categories = await ctx.gateway.serviceCategories();

	applyPageSeo(ctx, {
		title: `${copy.nav.contact} — ${copy.brand.name}`,
		description: copy.contact.lead,
	});

	return el(
		"div",
		{ class: "mb-view mb-view--contact" },
		el(
			"section",
			{ class: "mb-section mb-section--white" },
			el(
				"div",
				{ class: "mb-section__inner mb-contact__grid" },
				el(
					"div",
					null,
					breadcrumbs(ctx, [{ label: copy.nav.start, key: "home" }, { label: copy.nav.contact }]),
					el("h1", { class: "mb-pagehead__title" }, copy.contact.title),
					el("p", { class: "mb-pagehead__lead" }, copy.contact.lead),
					markerList(copy.contact.points),
				),
				contactForm(ctx, categories),
			),
		),
	);
}
